import isPropValid from '@emotion/is-prop-valid';
import styled from '@emotion/styled';
import css from '@styled-system/css';
import { variant } from 'styled-system';

import { DividerHorizontalProps } from './types';

const propsNotToForward = ['type', 'size'];

const DividerHorizontal = styled('hr', {
  shouldForwardProp: (prop) =>
    isPropValid(prop) && !propsNotToForward.includes(prop),
})<DividerHorizontalProps>(
  ({ color = 'neutrals.5', type }) =>
    css({
      height: '0px',
      margin: 0,
      borderWidth: 0,
      borderColor: color,
      ...(type === 'thick'
        ? { backgroundColor: color }
        : { backgroundColor: 'transparent' }),
    }),
  variant({
    prop: 'type',
    variants: {
      solid: {
        borderStyle: 'solid',
        borderTopWidth: 1,
        borderRadius: 1,
      },
      dashed: {
        borderStyle: 'dashed',
        borderTopWidth: 1,
      },
      thick: {
        height: '3px',
        borderRadius: 1,
      },
    },
  })
);

export default DividerHorizontal;
